import { render, staticRenderFns } from "./Footerphone.vue?vue&type=template&id=0847a62e&"
import script from "./Footerphone.vue?vue&type=script&lang=js&"
export * from "./Footerphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports